import _ from 'lodash'
import { runQuery } from '../../fetchUtils'

//note: task_id is an int from 0-8
// 0 - Visited Storylines Page
// 1 - ASsigned A Quest To themselves
// 2 - Created a character in game
// 3 - Completed a Quest in game
// ----------
// 4 - created a class
// 5 - has at least one student in a class
// 6 - has a student that has created a character in game
// 7 - has created an assignment for a student
// 8 - has a student that has completed an assignment

/*status and step_id array should be kept in sync with the one
 defined in the backend. The ordering of the step_id array also indicates
 the id of each of the associated steps. If the step_id array is to be
 modified in the future, all of it's associated functionalities for the 
 onboarding context/data should be reviewed and changed according if neccessary.
 */
export const status = [
    'disabled',
    'skipped',
    'inProgress',
    'completed',
    'advancedCompletion'
]

export const step_id = [
    'hasVisitedStorylines',
    'hasSelfAssigned',
    'hasCreatedCharacter',
    'hasCompletedQuest',
    'hasCreatedClass',
    'hasPopulatedClass',
    'hasStudentCreatedCharacter',
    'hasCreatedStudentAssignment',
    'hasStudentCompletedQuest'
]

//handles skipping action on onboarding homepage / onboarding banner
export const handleTaskSkip = (callbacks, vars) => {
    const onboardingSkipQuery = `
        mutation skipOnboardingStep($stepId: Int!){
            skipOnboardingTask(stepId:$stepId){
                updatedContext{
                    hasVisitedStorylines
                    hasSelfAssigned
                    hasCreatedCharacter
                    hasCompletedQuest
                    hasCreatedClass
                    hasPopulatedClass
                    hasStudentCreatedCharacter
                    hasCreatedStudentAssignment
                    hasStudentCompletedQuest
                    allCompletedSteps
                    personalOnboardingStepsCompleted
                    classOnboardingStepsCompleted
                    allOnboardingStepsCompleted
                }
                errors
            }
        }
    `
    runQuery(onboardingSkipQuery, vars, callbacks)
}

//handles completing action on onboarding homepage / onboarding banner
export const handleTaskComplete = (callbacks, vars) => {
    const onboardingUpdateQuery = `
        mutation CompleteOnboardingStep($stepId: Int!){
            completeOnboardingStep(stepId: $stepId){
                updatedContext{
                    hasVisitedStorylines
                    hasSelfAssigned
                    hasCreatedCharacter
                    hasCompletedQuest
                    hasCreatedClass
                    hasPopulatedClass
                    hasStudentCreatedCharacter
                    hasCreatedStudentAssignment
                    hasStudentCompletedQuest
                    allCompletedSteps
                    personalOnboardingStepsCompleted
                    classOnboardingStepsCompleted
                    allOnboardingStepsCompleted
                }
                errors
            }

        }
    `
    runQuery(onboardingUpdateQuery, vars, callbacks)
}

//handles fetching data on initial load for onboarding context
export const fetchOnboardingData = (callbacks) => {
    const onboardingGuideLoadQuery = `
        query LoadContext{
            instructorOnboardingContext{
                userUuid
                profile{
                    username
                }
                hasVisitedStorylines
                hasSelfAssigned
                hasCreatedCharacter
                hasCompletedQuest
                hasCreatedClass
                hasPopulatedClass
                hasStudentCreatedCharacter
                hasCreatedStudentAssignment
                hasStudentCompletedQuest
                allCompletedSteps
                personalOnboardingStepsCompleted
                classOnboardingStepsCompleted
                allOnboardingStepsCompleted
            }
        }
    `
    const vars = {}
    runQuery(onboardingGuideLoadQuery, vars, callbacks)
}

//handles query to request for slack notification
export const handleSlackOnboarding = (current_user, message) => {
    const vars = {
        message: `${current_user['first-name']} ${current_user['last-name']} (${current_user['email']}) has completed Teacher Onboarding ${message}`,
        channelName: '#educator_onboarding'
    }
    const callbacks = {
        onComplete: json => {
            let error = json.data.sendSlackNotification.errors
            if (!_.isEmpty(error)) {
                console.error(error)
            }
        },
        onFailure: error => { console.error(error) }
    }
    const onboardingSlackQuery = `
            mutation SendSlackNotification($message: String!, $channelName: String!){
                sendSlackNotification(message: $message, channelName: $channelName){
                    errors
                    hasQueuedMessage
                }
          }
        `
    runQuery(onboardingSlackQuery, vars, callbacks)
}

//converting return from graphql to usable object in onboarding context
export const convertTeacherStartTrack = (data) => {
    return {
        isAllCompleted: data.allOnboardingStepsCompleted,
        isPersonalOnboardingCompleted: data.personalOnboardingStepsCompleted,
        steps: {
            exploreContent: data.hasVisitedStorylines,
            assignYourself: data.hasSelfAssigned,
            getInGame: data.hasCreatedCharacter,
            completeQuest: data.hasCompletedQuest
        }

    }
}

export const convertStudentStartTrack = (data) => {
    return {
        isAllCompleted: data.allOnboardingStepsCompleted,
        isClassOnboardingCompleted: data.classOnboardingStepsCompleted,
        steps: {
            createClass: data.hasCreatedClass,
            addStudent: data.hasPopulatedClass,
            studentInGame: data.hasStudentCreatedCharacter,
            assignToStudent: data.hasCreatedStudentAssignment,
            studentCompleteQuest: data.hasStudentCompletedQuest
        }
    }
}